const CONTEXT_LATEST_DESIGN_VERSION = 10;
export { CONTEXT_LATEST_DESIGN_VERSION };
